import $ from 'jquery';

import { addToCart } from '@process-creative/slate-theme-tools';
import { QuantitySelector } from '../quantity/QuantitySelector';
import { CarouselSection } from './../../sections/carousel/CarouselSection';


export const CROSS_SELL_SELECTOR = '[data-cross-sell]';
export const CART_TEMPLATE_PRODUCT = '[data-cross-sell-template-product]';
const ITEM_QUANTITY = '[data-quantity-selector-field]';
export const CROSS_SELL_BODY = '[data-cross-sell-body]';
export const CROSS_SELL_CONTAINER = '[data-cross-sell-container]'


const VARIANT_ID = 'data-item';

const ADD_TO_CART = '[data-cross-sell-add-button]';


export class CartCrossSellLineItems extends CarouselSection {
  constructor(container) {
    super(container);
    this.container = container;
    this.carouselContainer = this.container.find(CROSS_SELL_BODY);
    this.onCartFinished(this.carouselContainer);
    this.timeout = false;
    $(document).on('click', ADD_TO_CART, e => this.onAddToCart(e));
  }

  async onAddToCart(e) {
    e.preventDefault();
    e.stopPropagation();
    let btn = $(e.currentTarget);
    let variantId = btn.closest(CART_TEMPLATE_PRODUCT).attr(VARIANT_ID);
    let quantity = btn.closest(CART_TEMPLATE_PRODUCT).find(ITEM_QUANTITY).val();
    
    btn.addClass('is-loading');
    btn.attr('disabled', 'disabled');

    try {
      await addToCart(variantId, quantity);
    } catch (e) {
      console.error(e);
    }

    btn.removeClass('is-loading');
    btn.removeAttr('disabled');
  }

  onCartFinished()  {
    //detach all add to cart events
    $(document).off('click', ADD_TO_CART);
    setTimeout(() => {
      this.setupQuantitySelectors();
    }, 500);
  }

  setupQuantitySelectors() {
    //Now recreate
    this.quantitySelectors = [];

    let products = $(document).find(CART_TEMPLATE_PRODUCT);
    products.each((e, i) => {
      let self = $(i);
      this.quantitySelectors.push(new QuantitySelector(self));
    });
    
  }
}